module.exports = __webpack_public_path__ + "img/de_Beta Digitis - Gif.cb667530.gif";